const common = {
  ok: "Ok",
  cancel: "Abbrechen",
  yes: "Ja",
  no: "Nein",
  openUserSettings: "Einstellungen für {{userName}} öffnen",
  all: "Alle",
  allCounselors: "Alle Berater:innen",
  allCourts: "Alle Gerichte",
  selectCounselor: "Berater:in wählen",
  serverError: "Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  networkError: "Die Verbindung zum Server konnte nicht hergestellt werden.",
  notFoundError: "Die angeforderte Ressource wurde nicht gefunden.",
  forbiddenError: "Sie haben keine Berechtigung für diese Aktion.",
  requestError: "Die Anfrage konnte nicht verarbeitet werden.",
  conflictError: "Die Anfrage konnte aufgrund eines Konflikts nicht verarbeitet werden.",
  validationError: "Die Anfrage enthält ungültige Daten.",
  close: "Schließen",
  copyMessage: "{{message}} kopieren",
  columnFilter: {
    filterBy: "Nach {{column}} filtern",
  },
  pagination: {
    label: "Seitennavigation",
    page: "Seite {{page}}",
    previousPage: "Vorherige Seite",
    nextPage: "Nächste Seite",
  },
  formDialog: {
    unsavedChangesTitle: "Seite verlassen?",
    unsavedChangesText:
      "Es gibt ungespeicherte Änderungen. Diese gehen beim Verlassen der Seite, ohne speichern, verloren.",
    discardChanges: "Schließen",
    leavePage: "Verlassen",
  },
  toFirstError: "Zum ersten Fehler",
  formValidationError: "Bitte überprüfen und korrigieren Sie die markierten Felder um zu speichern.",
  address: {
    street: "Straße",
    houseNumber: "Hausnummer/Stiege/Tür",
    zipCode: "PLZ",
    city: "Ort",
    country: "Land",
  },
  validation: {
    fieldRequired: "{{fieldName}} ist erforderlich",
    required: "Pflichtfeld",
    dateMinToday: "Das Datum darf nicht in der Vergangenheit liegen",
    invalidDateFormat: "Bitte geben Sie ein gültiges Datum im Format TT.MM.JJJJ ein",
    maxLength: "Maximal {{max}} Zeichen",
    minLength: "Minimal {{min}} Zeichen",
    minValue: "Der Wert darf nicht kleiner als {{min}} sein",
    invalidNumber: "Bitte geben Sie eine gültige Zahl ein",
  },
  iban: {
    invalid: "Ungültige IBAN",
    label: "IBAN",
    placeholder: "AT00 0000 0000 0000 0000",
  },
  fileNumber: {
    placeholder: "18 S 36/26p",
  },
  additionalInfo: {
    showFor: "Zusatzinfo zu {{field}} anzeigen",
    collapse: "Zusätzliche Informationen einklappen",
    expand: "Zusätzliche Informationen ausklappen",
  },
  optional: "optional",
  delete: "Löschen",
  override: "Überschreiben",
  print: "Drucken",
  edit: "Bearbeiten",
  notAvailable: "n/a",
  counselor: "Bearbeiter:in",
  client: "Kund:in",
  save: "Speichern",
  resetChanges: "Änderungen zurücksetzen",
  create: "Erstellen",
  clock: "Uhr",
  createdAtBy: "Erstellt am {{date}} von {{user}}",
  lastChanged: "Letzte Änderung am {{date}} von {{user}}",
  until: "bis",
  options: "Optionen",
  notImplemented: "noch nicht implementiert",
  noInformationAvailable: "Keine Informationen vorhanden",
  noEntriesFound: "Keine Einträge gefunden",
  fileActions: {
    openMenu: "Aktionen für {{fileName}} öffnen",
    preview: "Vorschau öffnen",
    rename: "Umbenennen",
    download: "Herunterladen",
    createCaseNote: "Als Aktenvermerk anlegen",
    convertToPdf: "In PDF umwandeln",
    convertToPdfConfirmTitle: "Dokument in PDF umwandeln",
    convertToPdfConfirmText:
      '"{{fileName}}" wird in ein PDF umgewandelt. Das Originaldokument wird dabei durch die PDF-Datei ersetzt.',
    convertToPdfConfirm: "Umwandeln",
    delete: "Löschen",
    restore: "Löschen rückgängig machen",
  },
};

export default common;
